// fechasPeru.js

/**
 * Obtiene la fecha y hora actual ajustada a la zona horaria de Perú (America/Lima).
 * 
 * @returns {Date}
 */
export function obtenerFechaActualPeru() {
  const ahora = new Date();
  
  const cadenaHoraPeru = ahora.toLocaleString('en-US', {
    timeZone: 'America/Lima',
    hour12: false,
  });

  return new Date(cadenaHoraPeru);
}

/**
 * Calcula el número total de días hábiles considerando la hora de corte de la configuración.
 * 
 * @param {Object|null} categoriaConDias - Objeto categoría.
 * @param {string|number} [horaCorteConfig='13:00'] - Valor de general.hora_corte_pedidos (ej: "13:00" o "13:00:00").
 * @param {number|null} [horaSimulada=null] - (Opcional) Hora en formato 0-23 para pruebas.
 * @returns {number} Días finales ajustados.
 */
export function calcularDiasHabilesFinales(categoriaConDias, horaCorteConfig = '13:00', horaSimulada = null) {
  const diasBase = categoriaConDias ? Number(categoriaConDias.dias_habiles) : 0;

  if (diasBase <= 0) {
    return 0;
  }

  // Extraemos solo el número entero de la hora (ej: "13:00:00" -> 13)
  const horaCorte = parseInt(horaCorteConfig, 10) || 13;

  // Hora actual en Perú (o la hora simulada si la estás testeando)
  const horaPeru = horaSimulada !== null ? horaSimulada : obtenerFechaActualPeru().getHours();

  // Evaluamos la regla
  const esPosteriorAlCorte = horaPeru >= horaCorte;

  return diasBase + (esPosteriorAlCorte ? 1 : 0);
}